import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { SubtitleStyle, VideoEditConfig } from '@packages/global';
import FontAppearanceDialog from './FontAppearanceDialog';

interface SubtitleSettingsDialogProps {
  episodeId?: string;
  editConfig: VideoEditConfig | null;
  isOpen: boolean;
  onClose: () => void;
  onChange: (config: VideoEditConfig) => void;
}

const DEFAULT_SUBTITLE_STYLE: SubtitleStyle = {
  fontSize: 18,
  color: '#ffffff',
  position: 'bottom',
  background: true,
  appearancePreset: 'white_black',
  fontId: undefined,
  fontName: undefined,
  fontUrl: undefined,
};

export default function SubtitleSettingsDialog({
  episodeId,
  editConfig,
  isOpen,
  onClose,
  onChange,
}: SubtitleSettingsDialogProps) {
  const { t } = useTranslation(['editor']);
  const subtitleStyle = useMemo(
    () => ({
      ...DEFAULT_SUBTITLE_STYLE,
      ...editConfig?.tracks?.subtitle?.style,
    }),
    [editConfig?.tracks?.subtitle?.style],
  );

  return (
    <FontAppearanceDialog
      episodeId={episodeId}
      isOpen={isOpen}
      onClose={onClose}
      title={t('subtitleSettings.title')}
      sampleText={t('subtitleSettings.previewText')}
      style={subtitleStyle}
      onConfirm={(nextStyle) => {
        if (!editConfig) {
          onClose();
          return;
        }

        onChange({
          ...editConfig,
          tracks: {
            ...editConfig.tracks,
            subtitle: {
              ...editConfig.tracks.subtitle,
              style: {
                ...subtitleStyle,
                ...nextStyle,
              },
            },
          },
        });
        onClose();
      }}
    />
  );
}
